import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useActionSheet } from '@expo/react-native-action-sheet';
import {
  airOptionMap,
  hotelOptionMap,
  carOptionMap,
  railOptionMap,
} from '../../utils/search.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';

import { AntDesign } from '@expo/vector-icons';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { Color, CommonStyles } from '../../styles';
import { selectTezEvent } from '../../store/selectors/events.selector';
import { useSelector } from 'react-redux';
import { EVENTS_ENABLED } from '../../config/env';

const SearchSubTypePicker = (props) => {
  const updateComponentMapForEvents = (tezEvent) => {
    const tempAirOptionMap = {};
    if (tezEvent.IsRoundTripAllowed) {
      tempAirOptionMap['roundtrip'] = 'AirRoundTripOption';
    }
    if (tezEvent.IsOneWayAllowed) {
      tempAirOptionMap['oneway'] = 'AirOneWayOption';
    }
    if (!tezEvent.IsRoundTripAllowed && !tezEvent.IsOneWayAllowed) {
      tempAirOptionMap['roundtrip'] = 'AirRoundTripOption';
    }
    return tempAirOptionMap;
  };
  const { rowBtnStyle, dominantSearchType, subSearchType, onSelection } = props;
  const { showActionSheetWithOptions } = useActionSheet();
  const { t } = useTranslation(i18nNS.searchWidget);
  const { tKey } = useComponentTKey('SearchSubTypePicker');
  const tezEvent = useSelector(selectTezEvent);
  const cancelButtonIndex = 7;
  const componentMap = {
    air:
      EVENTS_ENABLED && dominantSearchType === 'air'
        ? updateComponentMapForEvents(tezEvent)
        : airOptionMap,
    hotel: hotelOptionMap,
    car: carOptionMap,
    rail: railOptionMap,
  };

  const translatedSubTypeMap = Object.keys(componentMap[dominantSearchType]).reduce(
    (r, key) => ((r[key] = t(tKey(componentMap[dominantSearchType][key]))), r),
    {}
  );
  const translatedOptions = Object.values(translatedSubTypeMap);

  return (
    <TouchableOpacity
      style={rowBtnStyle}
      onPress={() => {
        showActionSheetWithOptions(
          { options: translatedOptions, cancelButtonIndex },
          (buttonIndex) => {
            switch (dominantSearchType) {
              case 'air':
                if (buttonIndex === 0) {
                  onSelection('roundtrip');
                } else if (buttonIndex === 1) {
                  onSelection('oneway');
                } else if (buttonIndex === 2) {
                  onSelection('multicity');
                }
                break;
              case 'hotel':
                if (buttonIndex === 0) {
                  onSelection('oneway');
                } else if (buttonIndex === 1) {
                  onSelection('multicity');
                }
                break;
              case 'car':
                if (buttonIndex === 0) {
                  onSelection('roundtrip');
                } else if (buttonIndex === 1) {
                  onSelection('oneway');
                }
                break;
              case 'rail':
                if (buttonIndex === 0) {
                  onSelection('roundtrip');
                } else if (buttonIndex === 1) {
                  onSelection('oneway');
                }
                break;
            }
          }
        );
      }}
    >
      <View style={styles.textContainer}>
        <Icon size={28} name="mark" style={CommonStyles.mr3} color={Color.text.low} />
        <BaseText style={CommonStyles.h2}>{translatedSubTypeMap[subSearchType]}</BaseText>
        <View style={CommonStyles.flex1}>
          <AntDesign style={CommonStyles.alignSelfToEnd} name="caretdown" size={18} />
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default memo(SearchSubTypePicker);
